// @ts-nocheck
/**
 * 住所フォーム関連機能
 * - 郵便番号からの住所自動補完（zipcloud API）
 * - 日本向けバリデーション
 *
 * 修正: mbs-ecに合わせて住所フォーム機能を追加
 * 注意: トグル機能はcustomer.jsで処理するため、ここでは実装しない
 */

const SELECTORS = {
  customerAddresses: "[data-customer-addresses]",
  addressZip: "[data-address-zip]",
  addressCountry: "[data-address-country]",
  addressProvince: "[data-address-province]",
  addressCity: "[data-address-city]",
  addressAddress1: "[data-address-address1]",
  addressPhone: "[data-address-phone]",
};

const PREFECTURE_MAPPING = {
  北海道: "Hokkaido",
  青森県: "Aomori",
  岩手県: "Iwate",
  宮城県: "Miyagi",
  秋田県: "Akita",
  山形県: "Yamagata",
  福島県: "Fukushima",
  茨城県: "Ibaraki",
  栃木県: "Tochigi",
  群馬県: "Gunma",
  埼玉県: "Saitama",
  千葉県: "Chiba",
  東京都: "Tokyo",
  神奈川県: "Kanagawa",
  新潟県: "Niigata",
  富山県: "Toyama",
  石川県: "Ishikawa",
  福井県: "Fukui",
  山梨県: "Yamanashi",
  長野県: "Nagano",
  岐阜県: "Gifu",
  静岡県: "Shizuoka",
  愛知県: "Aichi",
  三重県: "Mie",
  滋賀県: "Shiga",
  京都府: "Kyoto",
  大阪府: "Osaka",
  兵庫県: "Hyogo",
  奈良県: "Nara",
  和歌山県: "Wakayama",
  鳥取県: "Tottori",
  島根県: "Shimane",
  岡山県: "Okayama",
  広島県: "Hiroshima",
  山口県: "Yamaguchi",
  徳島県: "Tokushima",
  香川県: "Kagawa",
  愛媛県: "Ehime",
  高知県: "Kochi",
  福岡県: "Fukuoka",
  佐賀県: "Saga",
  長崎県: "Nagasaki",
  熊本県: "Kumamoto",
  大分県: "Oita",
  宮崎県: "Miyazaki",
  鹿児島県: "Kagoshima",
  沖縄県: "Okinawa",
};

async function fetchAddressByZip(zipCode) {
  try {
    const response = await fetch(
      `https://zipcloud.ibsnet.co.jp/api/search?zipcode=${zipCode}`,
    );
    const data = await response.json();

    if (data.status === 200 && data.results && data.results.length > 0) {
      return data.results[0];
    }
    return null;
  } catch (error) {
    console.error("郵便番号検索エラー:", error);
    return null;
  }
}

function fillAddressFromZipResult(form, result) {
  const provinceSelect = form.querySelector(SELECTORS.addressProvince);
  if (provinceSelect) {
    const provinceName = PREFECTURE_MAPPING[result.address1];
    if (provinceName) {
      const options = provinceSelect.querySelectorAll("option");
      for (const option of options) {
        if (
          option.value === provinceName ||
          option.textContent === result.address1
        ) {
          provinceSelect.value = option.value;
        }
      }
    }
  }

  const cityInput = form.querySelector(SELECTORS.addressCity);
  if (cityInput) {
    cityInput.value = result.address2;
  }

  const address1Input = form.querySelector(SELECTORS.addressAddress1);
  if (address1Input && !address1Input.value) {
    address1Input.value = result.address3 || "";
  }
}

function toggleError(input, showError, message = "") {
  const group =
    input.closest(".field") || input.closest(".p-address-form__group");
  if (!group) return;

  if (showError) {
    input.classList.add("p-address-form__input--error");
    input.setAttribute("aria-invalid", "true");
  } else {
    input.classList.remove("p-address-form__input--error");
    input.setAttribute("aria-invalid", "false");
  }

  let errorElement = group.querySelector(".p-address-form__error");
  if (showError) {
    if (!errorElement) {
      errorElement = document.createElement("span");
      errorElement.className = "p-address-form__error";
      group.appendChild(errorElement);
    }
    errorElement.textContent = message;
  } else if (errorElement) {
    errorElement.remove();
  }
}

function showSuccess(input, message) {
  const group =
    input.closest(".field") || input.closest(".p-address-form__group");
  if (!group) return;

  const existingSuccess = group.querySelector(".p-address-form__success");
  if (existingSuccess) {
    existingSuccess.remove();
  }

  const successElement = document.createElement("span");
  successElement.className = "p-address-form__success";
  successElement.textContent = message;
  group.appendChild(successElement);

  setTimeout(() => {
    successElement.remove();
  }, 3000);
}

async function handleZipInput(event) {
  const input = event.target;
  let value = input.value.replace(/[^0-9]/g, "");

  if (value.length > 3) {
    value = `${value.slice(0, 3)}-${value.slice(3, 7)}`;
  }

  input.value = value;

  const zipCode = value.replace("-", "");
  if (zipCode.length === 7) {
    const form = input.closest("form");
    if (!form) return;

    const countrySelect = form.querySelector(SELECTORS.addressCountry);
    const countryValue = countrySelect ? countrySelect.value : "";
    if (countrySelect && countryValue !== "Japan" && countryValue !== "JP") {
      return;
    }

    const result = await fetchAddressByZip(zipCode);
    if (result) {
      fillAddressFromZipResult(form, result);
      showSuccess(input, "住所を自動入力しました");
    }
  }
}

function validateZip(event) {
  const input = event.target;
  const value = input.value.replace("-", "");
  const isValid = /^\d{7}$/.test(value);

  toggleError(
    input,
    !isValid && value.length > 0,
    "郵便番号は7桁の数字で入力してください",
  );
  return isValid || value.length === 0;
}

function handlePhoneInput(event) {
  const input = event.target;
  input.value = input.value.replace(/[^0-9-]/g, "");
}

function validatePhone(event) {
  const input = event.target;
  const value = input.value.replace(/-/g, "");
  const isValid = /^0\d{9,10}$/.test(value);

  toggleError(
    input,
    !isValid && value.length > 0,
    "電話番号は0から始まる10〜11桁の数字で入力してください",
  );
  return isValid || value.length === 0;
}

function handleFormSubmit(event) {
  const form = event.target;
  let isValid = true;

  const requiredInputs = form.querySelectorAll(
    "input[required], select[required]",
  );
  for (const input of requiredInputs) {
    if (!input.value.trim()) {
      toggleError(input, true, "このフィールドは必須です");
      isValid = false;
    } else {
      toggleError(input, false);
    }
  }

  const zipInput = form.querySelector(SELECTORS.addressZip);
  if (zipInput?.value) {
    const zipValue = zipInput.value.replace("-", "");
    if (!/^\d{7}$/.test(zipValue)) {
      toggleError(zipInput, true, "郵便番号は7桁の数字で入力してください");
      isValid = false;
    }
  }

  const phoneInput = form.querySelector(SELECTORS.addressPhone);
  if (phoneInput?.value) {
    const phoneValue = phoneInput.value.replace(/-/g, "");
    if (!/^0\d{9,10}$/.test(phoneValue)) {
      toggleError(
        phoneInput,
        true,
        "電話番号は0から始まる10〜11桁の数字で入力してください",
      );
      isValid = false;
    }
  }

  if (!isValid) {
    event.preventDefault();
    const firstError = form.querySelector('[aria-invalid="true"]');
    if (firstError) {
      firstError.scrollIntoView({ behavior: "smooth", block: "center" });
      firstError.focus();
    }
  }
}

function setupJapanAddressFeatures(container) {
  const zipInputs = container.querySelectorAll(SELECTORS.addressZip);
  for (const input of zipInputs) {
    input.addEventListener("input", handleZipInput);
    input.addEventListener("blur", validateZip);
  }

  const phoneInputs = container.querySelectorAll(SELECTORS.addressPhone);
  for (const input of phoneInputs) {
    input.addEventListener("input", handlePhoneInput);
    input.addEventListener("blur", validatePhone);
  }

  const forms = container.querySelectorAll("form");
  for (const form of forms) {
    form.addEventListener("submit", handleFormSubmit);
  }
}

function initAddressForm() {
  const container = document.querySelector(SELECTORS.customerAddresses);
  if (!container) return;

  setupJapanAddressFeatures(container);
}

export { initAddressForm };
